import { Helmet } from "react-helmet-async";

function MetaDecorator({
  titulo,
  descripcion,
  subtitulo,
  keywords,
  url,
  canonical,
}) {
  return (
    <Helmet>
      <title>{titulo}</title>
      <meta name="title" content={subtitulo} />
      <meta name="description" content={descripcion} />
      <meta name="keywords" content={keywords} />
      <meta property="og:url" content={url} />
      <link rel="canonical" href={canonical} />
    </Helmet>
  );
}

export default MetaDecorator;
